import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import { Prefooter4OpinionStyles } from './styles';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import ButtonWithArrowOnHover from '../../buttonWithArrowOnHover/ButtonWithArrowOnHover';

export const Prefooter4Opinion = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <Prefooter4OpinionStyles>
      <div className="container">
        <h1>{getTranslationsByLangOrEng(interfaceLanguage, 'four_opinion_11')}</h1>
        <ButtonWithArrowOnHover
          link="https://portal.4polls.expert"
          arrowColor="#fff"
          textColor="#fff"
          borderColor="#fff"
          borderOnHover="#fff"
          background="transparent"
          hoverBackground="transparent"
          hoverTextColor="#fff"
          text={getTranslationsByLangOrEng(
            interfaceLanguage,
            'four_opinion_12',
          )}
        />
      </div>
    </Prefooter4OpinionStyles>
  );
};
